import { MonthPickerDate } from "@common/Components/MonthPickerDialog";
import { MonthYear } from "@common/types";

export class ProjectInProgressLifecycleSetterViewModel
{
    projectId: string | null = null;
    opened: boolean = false;

    startDate: MonthPickerDate | null = null;
    get defaultYear(): number | null { return this.startDate?.year ?? null; }
    get defaultMonth(): number | null { return this.startDate?.monthIndex ?? null; }

    minStartDate: Date | null = null;
    maxStartDate: Date | null = null;

    show(projectId: string, startDate: MonthYear | null)
    {
        this.projectId = projectId;
        this.startDate = startDate ? { year: startDate.Year, monthIndex: startDate.Month } : null;

        const today = new Date();
        const thisMonth = today.getMonth(); // Move to next month
        const thisMonthFirstDay = new Date(today.getFullYear(), thisMonth, 1);
        this.maxStartDate = thisMonthFirstDay;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.projectId = null;
        this.startDate = null;

        this.minStartDate = null;
        this.maxStartDate = null;
    }
}
